import React from 'react'

import Button from 'konyvesjatek-ui/dist/common/src/components/Button'

export default React.forwardRef(({ children, size = 'large', ...props }, ref) => {
    return <Button {...props} size={size} icon={children} ref={ref} />
})
